export default "__VITE_ASSET__a744cf61__"